<div style="position: relative; height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
  <div style="position: absolute; top: 0; width: 100%; height:100%">
    <lib-confetti></lib-confetti>
  </div>
  <div style="z-index: 1;">
    <lib-check-mark></lib-check-mark>
    <div>
      <h3 style="text-align: center;">
        Assessment Completed
      </h3>
      <p style="text-align: center;">
        Thank you for completing the assessment.
      </p>
    </div>
    @if (!change_innovators) {
      <div style="padding-left: 8rem; margin-top: 3rem;">
        <p><b>Next Steps...</b></p>
        <p>Your assessment report link will be emailed to you.</p>
        <div>Create your password to access your Owlhub account. Click <a [href]="forgotPassword"><b>here</b></a></div>
        <div style="color: #7c7676; margin-top: 1.5rem;">Already have an account ? Click 
          <a [href]="login">
            <b>here</b>
          </a>
        </div>
      </div>
    }
  </div>

</div>